module.exports = __webpack_public_path__ + "36a3e9a3dd82736bfcf23f28bb3ebc10.svg";